import { createAction, props } from "@ngrx/store";
import * as AdhocReportModels from "@ptg-member/types/models/adhoc-report.model";

export const GetCardListActionRequest = '[GetCardList/API] Send Request';
export const GetCardListActionSuccess = '[GetCardList/API] Success';
export const GetCardListActionFailure = '[GetCardList/API] Failure';
export const GetCardListActionClear = '[GetCardList/API] Clear';

export const GetDefaultFilterActionRequest = '[GetDefaultFilter/API] Send Request';
export const GetDefaultFilterActionSuccess = '[GetDefaultFilter/API] Success';
export const GetDefaultFilterActionFailure = '[GetDefaultFilter/API] Failure';
export const GetDefaultFilterActionClear = '[GetDefaultFilter/API] Clear';

export const GetDefaultTemplateActionRequest = '[GetDefaultTemplate/API] Send Request';
export const GetDefaultTemplateActionSuccess = '[GetDefaultTemplate/API] Success';
export const GetDefaultTemplateActionFailure = '[GetDefaultTemplate/API] Failure';
export const GetDefaultTemplateActionClear = '[GetDefaultTemplate/API] Clear';

export const GetCardConfigurationActionRequest = '[GetCardConfiguration/API] Send Request';
export const GetCardConfigurationActionSuccess = '[GetCardConfiguration/API] Success';
export const GetCardConfigurationActionFailure = '[GetCardConfiguration/API] Failure';
export const GetCardConfigurationActionClear = '[GetCardConfiguration/API] Clear';

export const GetTemplatesActionRequest = '[GetTemplates/API] Send Request';
export const GetTemplatesActionSuccess = '[GetTemplates/API] Success';
export const GetTemplatesActionFailure = '[GetTemplates/API] Failure';
export const GetTemplatesActionClear = '[GetTemplates/API] Clear';

export const GetTemplateActionRequest = '[GetTemplate/API] Send Request';
export const GetTemplateActionSuccess = '[GetTemplate/API] Success';
export const GetTemplateActionFailure = '[GetTemplate/API] Failure';
export const GetTemplateActionClear = '[GetTemplate/API] Clear';

export const GenerateAdhocReportActionRequest = '[GenerateAdhocReport/API] Send Request';
export const GenerateAdhocReportActionSuccess = '[GenerateAdhocReport/API] Success';
export const GenerateAdhocReportActionFailure = '[GenerateAdhocReport/API] Failure';
export const GenerateAdhocReportActionClear = '[GenerateAdhocReport/API] Clear';

export const CreateReportTemplateActionRequest = '[CreateReportTemplate/API] Send Request';
export const CreateReportTemplateActionSuccess = '[CreateReportTemplate/API] Success';
export const CreateReportTemplateActionFailure = '[CreateReportTemplate/API] Failure';
export const CreateReportTemplateActionClear = '[CreateReportTemplate/API] Clear';

export const UpdateReportTemplateActionRequest = '[UpdateReportTemplate/API] Send Request';
export const UpdateReportTemplateActionSuccess = '[UpdateReportTemplate/API] Success';
export const UpdateReportTemplateActionFailure = '[UpdateReportTemplate/API] Failure';
export const UpdateReportTemplateActionClear = '[UpdateReportTemplate/API] Clear';

export const RemoveReportTemplateActionRequest = '[RemoveReportTemplate/API] Send Request';
export const RemoveReportTemplateActionSuccess = '[RemoveReportTemplate/API] Success';
export const RemoveReportTemplateActionFailure = '[RemoveReportTemplate/API] Failure';
export const RemoveReportTemplateActionClear = '[RemoveReportTemplate/API] Clear';

export const RemoveReportAuditTrailActionRequest = '[RemoveReportAuditTrail/API] Send Request';
export const RemoveReportAuditTrailActionSuccess = '[RemoveReportAuditTrail/API] Success';
export const RemoveReportAuditTrailActionFailure = '[RemoveReportAuditTrail/API] Failure';
export const RemoveReportAuditTrailActionClear = '[RemoveReportAuditTrail/API] Clear';

export const GetAdhocReportActionRequest = '[GetAdhocReport/API] Send Request';
export const GetAdhocReportActionSuccess = '[GetAdhocReport/API] Success';
export const GetAdhocReportActionFailure = '[GetAdhocReport/API] Failure';
export const GetAdhocReportActionClear = '[GetAdhocReport/API] Clear';

export const getCardListAction = createAction(
    GetCardListActionRequest,
    props<{ request: AdhocReportModels.GetCardListRequest }>(),
);

export const getCardListSuccessAction = createAction(
    GetCardListActionSuccess,
    props<{ response: AdhocReportModels.GetCardListForReportResponse }>(),
);

export const getCardListFailAction = createAction(
    GetCardListActionFailure,
    props<{ error?: any }>()
);

export const clearCardListStateAction = createAction(
    GetCardListActionClear,
);

export const getDefaultFilterAction = createAction(
    GetDefaultFilterActionRequest,
    props<{ request: AdhocReportModels.GetDefaultFilterRequest }>(),
);

export const getDefaultFilterSuccessAction = createAction(
    GetDefaultFilterActionSuccess,
    props<{ response: AdhocReportModels.GetDefaultFilterResponse }>(),
);

export const getDefaultFilterFailAction = createAction(
    GetDefaultFilterActionFailure,
    props<{ error?: any }>()
);

export const clearDefaultFilterStateAction = createAction(
    GetDefaultFilterActionClear,
);

export const getDefaultTemplateAction = createAction(
    GetDefaultTemplateActionRequest,
    props<{ request: AdhocReportModels.GetDefaultTemplateRequest }>(),
);

export const getDefaultTemplateSuccessAction = createAction(
    GetDefaultTemplateActionSuccess,
    props<{ response: AdhocReportModels.GetDefaultTemplateResponse }>(),
);

export const getDefaultTemplateFailAction = createAction(
    GetDefaultTemplateActionFailure,
    props<{ error?: any }>()
);

export const clearDefaultTemplateStateAction = createAction(
    GetDefaultTemplateActionClear,
);

export const getCardConfigurationAction = createAction(
    GetCardConfigurationActionRequest,
    props<{ request: AdhocReportModels.GetCardConfigurationRequest }>(),
);

export const getCardConfigurationSuccessAction = createAction(
    GetCardConfigurationActionSuccess,
    props<{ response: AdhocReportModels.GetCardConfigurationResponse }>(),
);

export const getCardConfigurationFailAction = createAction(
    GetCardConfigurationActionFailure,
    props<{ error?: any }>()
);

export const clearCardConfigurationStateAction = createAction(
    GetCardConfigurationActionClear,
);

export const getTemplatesAction = createAction(
    GetTemplatesActionRequest,
);

export const getTemplatesSuccessAction = createAction(
    GetTemplatesActionSuccess,
    props<{ response: AdhocReportModels.GetTemplatesResponse }>(),
);

export const getTemplatesFailAction = createAction(
    GetTemplatesActionFailure,
    props<{ error?: any }>()
);

export const clearTemplatesStateAction = createAction(
    GetTemplatesActionClear,
);

export const getTemplateAction = createAction(
    GetTemplateActionRequest,
    props<{ request: AdhocReportModels.GetTemplateRequest }>(),
);

export const getTemplateSuccessAction = createAction(
    GetTemplateActionSuccess,
    props<{ response: AdhocReportModels.GetTemplateResponse }>(),
);

export const getTemplateFailAction = createAction(
    GetTemplateActionFailure,
    props<{ error?: any }>()
);

export const clearTemplateStateAction = createAction(
    GetTemplateActionClear,
);

export const generateAdhocReportAction = createAction(
    GenerateAdhocReportActionRequest,
    props<{ request: AdhocReportModels.GenerateAdhocReportRequest }>(),
);

export const generateAdhocReportSuccessAction = createAction(
    GenerateAdhocReportActionSuccess,
);

export const generateAdhocReportFailAction = createAction(
    GenerateAdhocReportActionFailure,
    props<{ error?: any }>()
);

export const clearGenerateAdhocReportStateAction = createAction(
    GenerateAdhocReportActionClear,
);

export const createReportTemplateAction = createAction(
    CreateReportTemplateActionRequest,
    props<{ request: AdhocReportModels.CreateReportTemplateRequest }>(),
);

export const createReportTemplateSuccessAction = createAction(
    CreateReportTemplateActionSuccess,
);

export const createReportTemplateFailAction = createAction(
    CreateReportTemplateActionFailure,
    props<{ error?: any }>()
);

export const clearCreateReportTemplateStateAction = createAction(
    CreateReportTemplateActionClear,
);

export const updateReportTemplateAction = createAction(
    UpdateReportTemplateActionRequest,
    props<{ request: AdhocReportModels.UpdateReportTemplateRequest }>(),
);

export const updateReportTemplateSuccessAction = createAction(
    UpdateReportTemplateActionSuccess,
);

export const updateReportTemplateFailAction = createAction(
    UpdateReportTemplateActionFailure,
    props<{ error?: any }>()
);

export const clearUpdateReportTemplateStateAction = createAction(
    UpdateReportTemplateActionClear,
);

export const removeReportTemplateAction = createAction(
    RemoveReportTemplateActionRequest,
    props<{ request: { templateId: string } }>(),
);

export const removeReportTemplateSuccessAction = createAction(
    RemoveReportTemplateActionSuccess,
);

export const removeReportTemplateFailAction = createAction(
    RemoveReportTemplateActionFailure,
    props<{ error?: any }>()
);

export const clearRemoveReportTemplateStateAction = createAction(
    RemoveReportTemplateActionClear,
);

export const removeReportAuditTrailAction = createAction(
    RemoveReportAuditTrailActionRequest,
    props<{ request: { reportId: string } }>(),
);

export const removeReportAuditTrailSuccessAction = createAction(
    RemoveReportAuditTrailActionSuccess,
);

export const removeReportAuditTrailFailAction = createAction(
    RemoveReportAuditTrailActionFailure,
    props<{ error?: any }>()
);

export const clearRemoveReportAuditTrailStateAction = createAction(
    RemoveReportAuditTrailActionClear,
);

export const getAdhocReportAction = createAction(
    GetAdhocReportActionRequest,
    props<{ request: AdhocReportModels.GetAdhocReportRequest }>(),
);

export const getAdhocReportSuccessAction = createAction(
    GetAdhocReportActionSuccess,
    props<{ response: AdhocReportModels.GetAdhocReportResponse }>(),
);

export const getAdhocReportFailAction = createAction(
    GetAdhocReportActionFailure,
    props<{ error?: any }>()
);

export const clearAdhocReportStateAction = createAction(
    GetAdhocReportActionClear,
);